<div role="dialog" aria-labelledby="dialogTitle">
  <div class="modal-content">
    <div class="modal-header">
      <h4 id="dialogTitle" role="header" class="modal-title module-title">{{"import.forecast.dialog.title"|translate}}
      </h4>
      <button [disabled]="!_enableCancel" type="button" value="Close" class="close" aria-label="Close"
              title="{{'dialog.box.close.tooltip'|translate}}"
              (click)="dismiss()" tabindex="-1" [disabled]="_isUploadingFile">
        <span class="icon-Close" aria-hidden="true"></span>
      </button>
    </div>
    <div class="modal-body">
      <wfm-plan-loading-overlay *ngIf="_isLoading"></wfm-plan-loading-overlay>
      <p-toast position="bottom-right"></p-toast>
      <div class="col-12">
        <div class="row">
          <div class='col-12 mt-3'>
            <p>
              {{"import.forecast.dialog.paragraph.template"| translate}}
              <button id="btn-download-template" type="button" class="btn-link btn-anchor"
                      (click)="download()"
                      [disabled]="_isUploadingFile">{{"import.forecast.dialog.template.link"| translate}}</button>.
            </p>
          </div>
        </div>
        <div class="row">
          <div class='col-12 mt-3'>
            <p [innerHTML]="'import.forecast.dialog.paragraph.important' | translate"></p>
          </div>
        </div>
        <div class="row">
          <div class='col-12 mt-3'>
            <button class="btn btn-secondary" (click)="fileInput.click()" title="{{'import.forecast.dialog.file.choose' | translate }}" [disabled]="_isUploadingFile">
              {{'import.forecast.dialog.file.choose' | translate }}
              <input #fileInput type="file" id="uploadFile" name="uploadFile"
                     (change)="onFileChange($event)" accept=".csv" style="display:none;" />
            </button>
            &nbsp;&nbsp;
            <span>{{_messageSelectedFile}}</span>
            <div *ngIf="_showError && !_showCheckBox" id="msgErrorValidation" class="error-message error-message-label" [innerHTML]="_errorMessage">
            </div>
            <div *ngIf="_showError && _showCheckBox" class="checkbox checkbox-inline error-message" id="chkboxErrorMessage">
              <input type="checkbox" id="errorChkbox" value="errorChkbox" [(ngModel)]="isConfirmed" (click)="enableUploadButton($event);">
              <label for="errorChkbox" title="{{_chkboxErrorMessage}}">{{_chkboxErrorMessage}}</label>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="_isUploadingFile">
          <div class='col-12 mt-3'>
            <span class="b-p-textlabel">{{'import.forecast.dialog.file.upload.progress.label' | translate}}</span>
            <div class="b-p-progress">
              <div id="b-progress-bar" [style.width]="_percentageLoaded + '%'" class="b-progress-bar" role="progressbar"></div>
            </div>
            <span id="b-p-label" class="b-p-label">{{_percentageLoaded}}%</span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="modal-buttons">
        <breeze-button buttonText="{{'import.forecast.dialog.cancel.button'|translate}}" id="cancel-btn"
                       [isSecondary]="true" [isDisabled]="!_enableCancel || _isUploadingFile" (clicked)="dismiss()">
        </breeze-button>
        <breeze-button buttonText="{{'import.forecast.dialog.upload.button'|translate}}" id="accept-btn"
                       [isPrimary]="true" [isDisabled]="!_enableAccept || _isUploadingFile" (clicked)="uploadFile()"
                       placement="top">
        </breeze-button>
      </div>
    </div>
  </div>
</div>
